import cn from "classnames";
import { Button } from "components/ui/Button";
import { SIGN_IN_ROUTE } from "constants/routesValues";
import { SITE_NAME } from "constants/siteName";
import { useSiteName } from "context/SiteName.context";
import { createRouteAction } from "utils/history.utils";
import style from "./EmailVerification.module.scss";

export const EmailVerification = ({ email }: { email: string }) => {
  const { siteName } = useSiteName();
  const isChineseBrothers = siteName === SITE_NAME.CHINESE_BROTHERS;

  return (
    <div
      className={cn(style.emailVerificationWrapper, {
        [style.emailVerificationWrapperChineseBrothers]: isChineseBrothers,
      })}
    >
      <h3 className={style.emailVerificationTitle}>Confirm your email</h3>
      <p className={style.emailVerificationDescription}>
        We sent the letter to {email} with link to confirm your email (it might be in your spam folder). Find it and
        follow the link.
      </p>
      <Button
        text="Back to Sign In"
        handleClick={() => createRouteAction(SIGN_IN_ROUTE)}
        type="button"
        className={cn(style.formButton, {
          [style.formButtonChineseBrothers]: isChineseBrothers,
        })}
      />
    </div>
  );
};
